<div class="form" [ngClass]="getLevelClass()">
  <div class="form__label">
    <basic-label [noIndent]="true"></basic-label>
  </div>

  <div
    class="form__inline-field-container form__inline-field-container--two-fields form--full-width form__inline-field-container-address"
  >
    <div class="form__field form--address-long__field--line-1">
      <div *ngIf="!isServer">
        <address-autocomplete
          #streetRef
          [propertyName]="questionItem.prop + '.street'"
          [placeholder]="'Line 1'"
          (setZip)="setZip($event)"
          [zipKept]="zipKept"
        ></address-autocomplete>
      </div>
      <div *ngIf="isServer">
        <basic-text-input [propertyName]="questionItem.prop + '.street'" [placeholder]="'Line 1'"></basic-text-input>
      </div>
    </div>

    <div class="form__field form--address-long__field--line-2">
      <basic-text-input
        #line2Ref
        [propertyName]="questionItem.prop + '.line1'"
        [placeholder]="'Line 2'"
      ></basic-text-input>
    </div>
  </div>

  <div class="form--address-long form__inline-field-container form--full-width">
    <div class="form__field">
      <basic-text-input #zipRef [propertyName]="questionItem.prop + '.zip'" [placeholder]="'Zip'"></basic-text-input>
    </div>

    <div class="form__field">
      <basic-text-input #cityRef [propertyName]="questionItem.prop + '.city'" [placeholder]="'City'"></basic-text-input>
    </div>

    <div class="form__field">
      <basic-text-input
        #stateRef
        [propertyName]="questionItem.prop + '.state'"
        [placeholder]="'State'"
        [isState]="true"
      ></basic-text-input>
    </div>
  </div>

  <basic-checkbox
    *ngIf="showCheckbox"
    #prefillOwnerCheckbox
    (change)="onCheckboxChange()"
    [labelText]="checkboxText"
    [propertyName]="questionItem.prop + '.prefillOwnerAddressWithInsured'"
  ></basic-checkbox>

  <div>
    <p *ngIf="questionItem.subtext" class="subtext">{{ questionItem.subtext }}</p>
  </div>

  <p class="form--address-long__error error-message" *ngIf="isError()">
    {{ getErrorMessage() }}
  </p>
</div>
